import React from 'react'
import { Route, Switch } from 'react-router-dom'

const AppRouter = route => {
  return (
    <Switch>
      <Route
        path={route.match.path}
        render={routeProps => (
          <React.Fragment>
            {require('./QRCode').default(routeProps)}
            {require('./Scanned').default(routeProps)}
            {require('./Confirm').default(routeProps)}
            {require('./Result').default(routeProps)}
            {require('./ComingSoon').default(routeProps)}
          </React.Fragment>
        )}
      />
    </Switch>
  )
}

export default AppRouter
